import { services } from "@/util";

export const Services = () => (
  <div className="section !pb-20 md:!py-40 grid grid-cols-1 md:grid-cols-2 mx-0 gap-28 xl:mx-60 items-center">
    <div className="mt-20 md:mt-0">
      <div className="tracking-tight text-2xl md:text-3xl lg:text-6xl first-letter:capitalize">
        services
      </div>
      <div className="desc pr-10 md:pr-20 xl:pr-40 !mt-2 first-letter:capitalize">
        for fast growing tech and development companies
      </div>
      <ul className="space-y-1.5 mt-6 md:mt-4 capitalize">
        {services.map((service) => (
          <li
            className="flex items-center text-sm md:text-base gap-2 min-w-max"
            key={service}
          >
            <svg
              className="w-4 h-4 fill-themeWhite"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
            </svg>
            {service}
          </li>
        ))}
      </ul>
    </div>
    <div className="flex justify-center order-first md:order-last mt-20 md:mt-0">
      <div className="relative">
        <div className="techstack-top">
          <svg width="34px" height="34px" viewBox="0 0 48 48">
            <radialGradient
              id="LYQUbLCUr5f7yOz~opfH_a"
              cx="23.941"
              cy="4.412"
              r="54.398"
              gradientTransform="matrix(1 0 0 .6044 0 1.745)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".202" stopColor="#27f5f1" />
              <stop offset=".29" stopColor="#25e2ee" />
              <stop offset=".468" stopColor="#20b1e7" />
              <stop offset=".717" stopColor="#1963db" />
              <stop offset=".857" stopColor="#1434d4" />
              <stop offset="1" stopColor="#0015b5" />
            </radialGradient>
            <path
              fill="url(#LYQUbLCUr5f7yOz~opfH_a)"
              d="M34.249,42H13.751C9.47,42,6,38.53,6,34.249v-10.78L21,6h13.248C38.53,6,42,9.47,42,13.751 v20.497C42,38.53,38.53,42,34.249,42z"
            />
            <path
              fill="#1a5cf9"
              d="M21,6L6,23.469c4.325,5.751,14.813,9.78,21.688,3.468c4-5,1.688-13.188-1.313-15.875 C24.868,9.712,23.064,7.77,21,6z"
            />
            <path
              fill="#21aaf5"
              d="M21,6L6,21.683v1.786c5.079,3.953,13.005,5.51,18.563,0.406c4-5,1.688-13.188-1.313-15.875 C22.613,7.43,21.848,6.735,21,6z"
            />
            <path
              fill="#25e0f2"
              d="M6,18.477v3.206c4.686,1.975,10.315,1.966,14.563-1.933C23.787,15.72,23.033,9.622,21,6h-3.15 L6,18.477z"
            />
            <path
              fill="#18ffff"
              d="M13.751,6C9.47,6,6,9.47,6,13.751v4.726c3.476,0.382,7.055-0.459,9.979-3.144 c2.119-2.649,2.46-6.188,1.871-9.333H13.751z"
            />
            <path d="M12.608,14.87c0,0,6.833,10.327,12.578,13.82c-2.174,0.699-6.894,3.555-15.124-1.492c2.096,2.873,5.807,8.635,14.891,8.092 c3.183-0.155,5.124-1.165,6.91-1.863c1.786-0.698,3.494-0.621,4.969,2.019c0.311-2.407,0.388-4.659-2.096-7.221 c0,0,2.456-9.363-8.001-16.751c2.174,4.348,3.433,6.8,2.411,12.791c-2.329-1.553-10.931-8.48-12.872-10.732 c1.398,2.485,5.419,7.936,6.816,9.334C20.606,21.159,12.608,14.87,12.608,14.87z" />
          </svg>
        </div>
        <div className="techstack-tl">
          <svg
            width="60px"
            height="60px"
            x="0px"
            y="0px"
            viewBox="0 0 400 400"
            enableBackground="new 0 0 400 400"
          >
            <g>
              <rect
                x="122"
                y="-0.4"
                transform="matrix(-0.866 -0.5 0.5 -0.866 163.3196 363.3136)"
                fill="#E535AB"
                width="16.6"
                height="320.3"
              />
            </g>
            <g>
              <rect
                x="39.8"
                y="272.2"
                fill="#E535AB"
                width="320.3"
                height="16.6"
              />
            </g>
            <g>
              <rect
                x="37.9"
                y="312.2"
                transform="matrix(-0.866 -0.5 0.5 -0.866 83.0693 663.3409)"
                fill="#E535AB"
                width="185"
                height="16.6"
              />
            </g>
            <g>
              <rect
                x="177.1"
                y="71.1"
                transform="matrix(-0.866 -0.5 0.5 -0.866 463.3409 283.0693)"
                fill="#E535AB"
                width="185"
                height="16.6"
              />
            </g>
            <g>
              <rect
                x="122.1"
                y="-13"
                transform="matrix(-0.5 -0.866 0.866 -0.5 126.7903 232.1221)"
                fill="#E535AB"
                width="16.6"
                height="185"
              />
            </g>
            <g>
              <rect
                x="109.6"
                y="151.6"
                transform="matrix(-0.5 -0.866 0.866 -0.5 266.0828 473.3766)"
                fill="#E535AB"
                width="320.3"
                height="16.6"
              />
            </g>
            <g>
              <rect
                x="52.5"
                y="107.5"
                fill="#E535AB"
                width="16.6"
                height="185"
              />
            </g>
            <g>
              <rect
                x="330.9"
                y="107.5"
                fill="#E535AB"
                width="16.6"
                height="185"
              />
            </g>
            <g>
              <rect
                x="262.4"
                y="240.1"
                transform="matrix(-0.5 -0.866 0.866 -0.5 126.7953 714.2875)"
                fill="#E535AB"
                width="14.5"
                height="160.9"
              />
            </g>
            <path
              fill="#E535AB"
              d="M369.5,297.9c-9.6,16.7-31,22.4-47.7,12.8c-16.7-9.6-22.4-31-12.8-47.7c9.6-16.7,31-22.4,47.7-12.8
                        C373.5,259.9,379.2,281.2,369.5,297.9"
            />
            <path
              fill="#E535AB"
              d="M90.9,137c-9.6,16.7-31,22.4-47.7,12.8c-16.7-9.6-22.4-31-12.8-47.7c9.6-16.7,31-22.4,47.7-12.8
                        C94.8,99,100.5,120.3,90.9,137"
            />
            <path
              fill="#E535AB"
              d="M30.5,297.9c-9.6-16.7-3.9-38,12.8-47.7c16.7-9.6,38-3.9,47.7,12.8c9.6,16.7,3.9,38-12.8,47.7
                        C61.4,320.3,40.1,314.6,30.5,297.9"
            />
            <path
              fill="#E535AB"
              d="M309.1,137c-9.6-16.7-3.9-38,12.8-47.7c16.7-9.6,38-3.9,47.7,12.8c9.6,16.7,3.9,38-12.8,47.7
                        C340.1,159.4,318.7,153.7,309.1,137"
            />
            <path
              fill="#E535AB"
              d="M200,395.8c-19.3,0-34.9-15.6-34.9-34.9c0-19.3,15.6-34.9,34.9-34.9c19.3,0,34.9,15.6,34.9,34.9
                        C234.9,380.1,219.3,395.8,200,395.8"
            />
            <path
              fill="#E535AB"
              d="M200,74c-19.3,0-34.9-15.6-34.9-34.9c0-19.3,15.6-34.9,34.9-34.9c19.3,0,34.9,15.6,34.9,34.9
                        C234.9,58.4,219.3,74,200,74"
            />
          </svg>
        </div>
        <div className="techstack-tr">
          <svg width="60px" height="60px" fill="none" viewBox="0 0 512 512">
            <path
              clipRule="evenodd"
              d="m316.939 407.424v50.061c8.138 4.172 17.763 7.3 28.875 9.386s22.823 3.129 35.135 3.129c11.999 0 23.397-1.147 34.196-3.442 10.799-2.294 20.268-6.075 28.406-11.342 8.138-5.266 14.581-12.15 19.328-20.65s7.121-19.007 7.121-31.522c0-9.074-1.356-17.026-4.069-23.857s-6.625-12.906-11.738-18.225c-5.112-5.319-11.242-10.091-18.389-14.315s-15.207-8.213-24.18-11.967c-6.573-2.712-12.468-5.345-17.685-7.9-5.217-2.556-9.651-5.163-13.303-7.822-3.652-2.66-6.469-5.476-8.451-8.448-1.982-2.973-2.974-6.336-2.974-10.091 0-3.441.887-6.544 2.661-9.308s4.278-5.136 7.512-7.118c3.235-1.981 7.199-3.52 11.894-4.615 4.696-1.095 9.912-1.642 15.651-1.642 4.173 0 8.581.313 13.224.938 4.643.626 9.312 1.591 14.008 2.894 4.695 1.304 9.259 2.947 13.694 4.928 4.434 1.982 8.529 4.276 12.285 6.884v-46.776c-7.616-2.92-15.937-5.084-24.962-6.492s-19.381-2.112-31.066-2.112c-11.895 0-23.163 1.278-33.805 3.833s-20.006 6.544-28.093 11.967c-8.086 5.424-14.476 12.333-19.171 20.729-4.695 8.395-7.043 18.433-7.043 30.114 0 14.914 4.304 27.638 12.912 38.172 8.607 10.533 21.675 19.45 39.204 26.751 6.886 2.816 13.303 5.579 19.25 8.291s11.086 5.528 15.415 8.448c4.33 2.92 7.747 6.101 10.252 9.543 2.504 3.441 3.756 7.352 3.756 11.733 0 3.233-.783 6.231-2.348 8.995s-3.939 5.162-7.121 7.196-7.147 3.624-11.894 4.771c-4.748 1.148-10.303 1.721-16.668 1.721-10.851 0-21.597-1.903-32.24-5.71-10.642-3.806-20.502-9.516-29.579-17.13zm-84.159-123.342h64.22v-41.082h-179v41.082h63.906v182.918h50.874z"
              fill="#fff"
              fillRule="evenodd"
            />
          </svg>
        </div>
        <div className="techstack-bottom">
          <svg width="60px" height="60px" viewBox="0 0 24 24">
            <path
              fill="#0DB7ED"
              fillRule="evenodd"
              d="M6.94221099,14.9002344 C6.9980621,14.9002344 7.05128211,14.9107588 7.10043586,14.9297745 C7.04721586,14.9606302 7.01109801,15.018335 7.01109801,15.0842919 C7.01109801,15.1828984 7.09098782,15.2626686 7.18959432,15.2626686 C7.25710599,15.2626686 7.31570779,15.2251754 7.34608506,15.1698027 C7.36743286,15.2214082 7.37939241,15.2780367 7.37939241,15.3374756 C7.37939241,15.578939 7.18361455,15.774657 6.94221099,15.774657 C6.70080744,15.774657 6.50496978,15.578939 6.50496978,15.3374756 C6.50496978,15.0959525 6.70080744,14.9002344 6.94221099,14.9002344 L6.94221099,14.9002344 Z M6.94221099,16.0853662 C6.52978585,16.0853662 6.19420083,15.7499008 6.19420083,15.3374756 C6.19420083,14.9250505 6.52978585,14.5895253 6.94221099,14.5895253 C7.35457634,14.5895253 7.69010156,14.9250505 7.69010156,15.3374756 C7.69010156,15.7499008 7.35457634,16.0853662 6.94221099,16.0853662 L6.94221099,16.0853662 Z M20.3859431,11.1838037 C18.2619865,16.8117894 13.4653093,19.318631 7.81023526,19.318631 C5.13823222,19.318631 3.00656172,18.3995992 1.64323262,16.8672219 L1.65327865,16.8605843 C2.04609012,16.880497 2.39758135,16.8872541 2.75439457,16.8872541 C3.08065114,16.8872541 3.39979178,16.8838457 3.6953721,16.8672219 C3.72108514,16.8657867 3.75325633,16.8621989 3.77878997,16.8605843 C3.77902916,16.8605245 3.86998155,16.8546046 3.82549202,16.853887 C4.57667146,16.8075437 5.15892224,16.7031368 5.70188589,16.5482008 C5.70200548,16.548141 5.70212508,16.548141 5.70224467,16.5480812 C5.80091098,16.5198567 5.89658739,16.4901372 5.98825735,16.4583846 C6.09081051,16.4228049 6.14510687,16.3108635 6.109587,16.2083104 C6.07406714,16.1056974 5.96218553,16.0512815 5.85957258,16.0869807 C5.16992503,16.3259326 4.26010213,16.4574876 3.14505333,16.4821841 L3.14475434,16.4821841 C2.57739321,16.4947416 1.95717085,16.4797922 1.28450587,16.4365584 L1.28444607,16.4365584 C1.14529669,16.2507668 1.01649231,16.0576798 0.89869073,15.8577161 L0.71248051,15.5172277 C0.149903198,14.4112083 -0.0964037696,13.1191582 0.0343141305,11.7160038 L16.3965356,11.7160038 C17.7407294,11.7160038 19.0534696,11.2143604 19.6764427,10.6609919 C18.5601381,9.75332174 18.670764,7.59731356 19.3822377,6.774616 C19.9997093,7.270758 20.9954018,8.31584342 20.824141,9.64622396 C21.6011531,9.255625 22.9506091,9.06259783 24,9.66816973 C23.3411483,10.9541803 21.8929064,11.3383809 20.3859431,11.1838037 L20.3859431,11.1838037 Z M2.25508329,11.3188869 L4.46771995,11.3188869 L4.46771995,9.1061306 L2.25508329,9.1061306 L2.25508329,11.3188869 Z M4.80808879,11.3188869 L7.02096464,11.3188869 L7.02096464,9.1061306 L4.80808879,9.1061306 L4.80808879,11.3188869 Z M4.80808879,8.76576176 L7.02096464,8.76576176 L7.02096464,6.5530653 L4.80808879,6.5530653 L4.80808879,8.76576176 Z M7.36127369,11.3188869 L9.57402994,11.3188869 L9.57402994,9.1061306 L7.36127369,9.1061306 L7.36127369,11.3188869 Z M7.36127369,8.76576176 L9.57402994,8.76576176 L9.57402994,6.5530653 L7.36127369,6.5530653 L7.36127369,8.76576176 Z M9.91433899,11.3188869 L12.1270952,11.3188869 L12.1270952,9.1061306 L9.91433899,9.1061306 L9.91433899,11.3188869 Z M9.91433899,8.76576176 L12.1270952,8.76576176 L12.1270952,6.5530653 L9.91433899,6.5530653 L9.91433899,8.76576176 Z M9.91433899,6.21275626 L12.1270952,6.21275626 L12.1270952,4 L9.91433899,4 L9.91433899,6.21275626 Z M12.4674043,11.3188869 L14.6801605,11.3188869 L14.6801605,9.1061306 L12.4674043,9.1061306 L12.4674043,11.3188869 Z"
            />
          </svg>
        </div>
        <div className="techstack-br">
          <svg width="60px" height="60px" viewBox="-11.5 -10.23174 23 20.46348">
            <circle cx="0" cy="0" r="2.05" fill="#61dafb" />
            <g stroke="#61dafb" strokeWidth="1" fill="none">
              <ellipse rx="11" ry="4.2" />
              <ellipse rx="11" ry="4.2" transform="rotate(60)" />
              <ellipse rx="11" ry="4.2" transform="rotate(120)" />
            </g>
          </svg>
        </div>
        <div className="techstack-bl">
          <svg
            width="60px"
            height="60px"
            fill="#3DDC84"
            viewBox="0 0 918.6 515.1"
            enableBackground="new 0 0 918.6 515.1"
          >
            <g>
              <path d="M918.6 515.1h-918.6c14.7-155.7 103.7-288.7 235.1-359.9l-76.2-132c-4.3-7.4-1.8-16.8 5.6-21.1s16.8-1.8 21.1 5.6l77.2 133.7c58.9-26.9 125.2-41.9 196.5-41.9s137.6 15 196.5 41.9l77.2-133.7c4.2-7.4 13.7-9.9 21-5.6s9.9 13.7 5.6 21.1l-76.2 132c131.5 71.2 220.5 204.2 235.2 359.9zm-248.5-129c21.3 0 38.6-17.3 38.5-38.5 0-21.2-17.2-38.5-38.5-38.5-21.2 0-38.5 17.2-38.5 38.5 0 21.2 17.2 38.5 38.5 38.5zm-421.7 0c21.3 0 38.6-17.3 38.5-38.5 0-21.2-17.2-38.5-38.5-38.5-21.2 0-38.5 17.2-38.5 38.5 0 21.2 17.2 38.5 38.5 38.5z" />
            </g>
          </svg>
        </div>
        <div className="techstack-center">
          <svg width="90px" height="90px" viewBox="0 0 394 80" fill="none">
            <path
              d="M261.919 0.0330722H330.547V12.7H303.323V79.339H289.71V12.7H261.919V0.0330722Z"
              fill="#fff"
            />
            <path
              d="M149.052 0.0330722V12.7H94.0421V33.0772H138.281V45.7441H94.0421V66.6721H149.052V79.339H80.43V12.7H80.4243V0.0330722H149.052Z"
              fill="#fff"
            />
            <path
              d="M183.32 0.0661486H165.506L229.312 79.3721H247.178L215.271 39.7464L247.127 0.126654L229.312 0.154184L206.352 28.6697L183.32 0.0661486Z"
              fill="#fff"
            />
            <path
              d="M201.6 56.7148L192.679 45.6229L165.455 79.4326H183.32L201.6 56.7148Z"
              fill="#fff"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M80.907 79.339L17.0151 0H0V79.3059H13.6121V16.9516L63.8067 79.339H80.907Z"
              fill="#fff"
            />
            <path
              d="M333.607 78.8546C332.61 78.8546 331.762 78.5093 331.052 77.8186C330.342 77.1279 329.991 76.2917 330 75.3011C329.991 74.3377 330.342 73.5106 331.052 72.8199C331.762 72.1292 332.61 71.7838 333.607 71.7838C334.566 71.7838 335.405 72.1292 336.115 72.8199C336.835 73.5106 337.194 74.3377 337.204 75.3011C337.194 75.9554 337.028 76.5552 336.696 77.0914C336.355 77.6368 335.922 78.064 335.377 78.373C334.842 78.6911 334.252 78.8546 333.607 78.8546Z"
              fill="#fff"
            />
            <path
              d="M356.84 45.4453H362.872V68.6846C362.863 70.8204 362.401 72.6472 361.498 74.1832C360.585 75.7191 359.321 76.8914 357.698 77.7185C356.084 78.5364 354.193 78.9546 352.044 78.9546C350.079 78.9546 348.318 78.6001 346.75 77.9094C345.182 77.2187 343.937 76.1826 343.024 74.8193C342.101 73.456 341.649 71.7565 341.649 69.7207H347.691C347.7 70.6114 347.903 71.3838 348.29 72.0291C348.677 72.6744 349.212 73.1651 349.895 73.5105C350.586 73.8559 351.38 74.0286 352.274 74.0286C353.243 74.0286 354.073 73.8286 354.746 73.4196C355.419 73.0197 355.936 72.4199 356.296 71.6201C356.646 70.8295 356.831 69.8479 356.84 68.6846V45.4453Z"
              fill="#fff"
            />
            <path
              d="M387.691 54.5338C387.544 53.1251 386.898 52.0254 385.773 51.2438C384.638 50.4531 383.172 50.0623 381.373 50.0623C380.11 50.0623 379.022 50.2532 378.118 50.6258C377.214 51.0075 376.513 51.5164 376.033 52.1617C375.554 52.807 375.314 53.5432 375.295 54.3703C375.295 55.061 375.461 55.6608 375.784 56.1607C376.107 56.6696 376.54 57.0968 377.103 57.4422C377.656 57.7966 378.274 58.0874 378.948 58.3237C379.63 58.56 380.313 58.76 380.995 58.9236L384.14 59.6961C385.404 59.9869 386.631 60.3778 387.802 60.8776C388.973 61.3684 390.034 61.9955 390.965 62.7498C391.897 63.5042 392.635 64.413 393.179 65.4764C393.723 66.5397 394 67.7848 394 69.2208C394 71.1566 393.502 72.8562 392.496 74.3285C391.491 75.7917 390.043 76.9369 388.143 77.764C386.252 78.582 383.965 79 381.272 79C378.671 79 376.402 78.6002 374.493 77.8004C372.575 77.0097 371.08 75.8463 370.001 74.3194C368.922 72.7926 368.341 70.9294 368.258 68.7391H374.235C374.318 69.8842 374.687 70.8386 375.314 71.6111C375.95 72.3745 376.78 72.938 377.795 73.3197C378.819 73.6923 379.962 73.8832 381.226 73.8832C382.545 73.8832 383.707 73.6832 384.712 73.2924C385.708 72.9016 386.492 72.3564 387.055 71.6475C387.627 70.9476 387.913 70.1206 387.922 69.1754C387.913 68.312 387.654 67.5939 387.156 67.0304C386.649 66.467 385.948 65.9944 385.053 65.6127C384.15 65.231 383.098 64.8856 381.899 64.5857L378.081 63.6223C375.323 62.9225 373.137 61.8592 371.541 60.4323C369.937 59.0054 369.143 57.115 369.143 54.7429C369.143 52.798 369.678 51.0894 370.758 49.6261C371.827 48.1629 373.294 47.0268 375.148 46.2179C377.011 45.4 379.114 45 381.456 45C383.836 45 385.92 45.4 387.719 46.2179C389.517 47.0268 390.929 48.1538 391.952 49.5897C392.976 51.0257 393.511 52.6707 393.539 54.5338H387.691Z"
              fill="#fff"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
);
